import React from 'react';
import CourierRequestForm from '../components/CourierRequestForm';
import './CourierRequestPage.css';

const CourierRequestPage = () => {
  return (
    <div className="page-container">
      {/* Header */}
      <header className="header">
  <div className="header-container">
    <div className="logo-container">
      <a href="/courier">
        <img 
          src={require('../assets/images/courierLogo.png')}
          alt="Weedhurry Logo"
        />
      </a>
      <h1 className="site-title"></h1>
    </div>
    <nav>
      <ul className="nav-menu">
        <li className="nav-item">
          <a href="/courier-login" className="nav-link">Login</a>
        </li>
      </ul>
    </nav>
  </div>
</header>

      {/* Main Content */}
      <main className="main-content">
        <div className="content-container">
          <div className="page-section">
            <h2 className="page-title">Request a Courier</h2>
            <p className="page-description">
              Fill out the form below to request a courier for your cannabis delivery. Our couriers will pick up your order and deliver it to your customers quickly and discreetly.
            </p>
            <CourierRequestForm />
          </div>
          
          <div className="info-section">
            <h3 className="info-title">How It Works</h3>
            <div className="steps-container">
              <div className="step-card">
                <div className="step-number">1</div>
                <h4 className="step-title">Request a Courier</h4>
                <p className="step-description">Fill out the form with your order details and submit your request.</p>
              </div>
              <div className="step-card">
                <div className="step-number">2</div>
                <h4 className="step-title">Courier Assignment</h4>
                <p className="step-description">Our system will find and assign the nearest available courier to your order.</p>
              </div>
              <div className="step-card">
                <div className="step-number">3</div>
                <h4 className="step-title">Quick Pickup & Delivery</h4>
                <p className="step-description">The courier will arrive, pay, and deliver your products to the customer safely.</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-section">
              <h3 className="footer-title">WeedHurry</h3>
              <p className="footer-text">
                Your trusted cannabis delivery platform connecting dispensaries with reliable couriers.
              </p>
            </div>
            <div className="footer-section">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-menu">
                <li className="footer-menu-item">
                  <a href="/" className="footer-link">Home</a>
                </li>
                <li className="footer-menu-item">
                  <a href="/courier" className="footer-link">Services</a>
                </li>
                <li className="footer-menu-item">
                  <a href="/contact" className="footer-link">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h3 className="footer-title">Resources</h3>
              <ul className="footer-menu">
                <li className="footer-menu-item">
                  <a href="/courier#wh-faq" className="footer-link">FAQ</a>
                </li>
                <li className="footer-menu-item">
                  <a href="/terms" className="footer-link">Terms of Service</a>
                </li>
                <li className="footer-menu-item">
                  <a href="/terms" className="footer-link">Privacy Policy</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h3 className="footer-title">Connect With Us</h3>
              <p className="contact-info">
                Contact Us: <a href="mailto:info@weedhurry.com" className="footer-link underline">info@weedhurry.com</a>
              </p>
            </div>
          </div>
          <div className="footer-divider">
            <p>© {new Date().getFullYear()} WeedHurry. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CourierRequestPage;